import type { IRhizomPageProps } from "@/types/RhizomPageProps/RhizomPageProps";
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";

export default () => {
    const inertiaProps = usePage<IRhizomPageProps>();

    const hasReportsAccess = computed(() => {
        // Past due payment
        if (
            inertiaProps.props.isCurrentSubscriptionPastDue === true &&
            inertiaProps.props.isSubscribed === true
        ) {
            return false;
        }

        // Admin users have access to all features regardless of subscription
        if (inertiaProps.props.isAdmin || inertiaProps.props.hasGodMode) {
            return true;
        }

        // Team must have trial or any subscription to access reports
        if (inertiaProps.props.isTrialing || inertiaProps.props.isSubscribed) {
            return true;
        }

        return inertiaProps.props.hasFreePlan;
    });

    return {
        hasReportsAccess,
    };
};
